import { createContext } from 'react';

export type AddGroupContactCtx = {
  showAddGroupContactErrorAlert: boolean;
  addGroupContactError: string;
};

const AddGroupContactDialogueContext = createContext<AddGroupContactCtx>({
  showAddGroupContactErrorAlert: false,
  addGroupContactError: '',
});

export default AddGroupContactDialogueContext;